import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Button } from '@mui/material';
import { BuildRounded } from '@mui/icons-material';
import { useAnchor, useCallbacks } from 'shared/hooks/utils';
import { ProPopup } from 'console/account/popup-for-pro';
import { getTariffProName } from 'console/billing/account-tariff/utils';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { DeviceControlMenu } from './control-menu';
import { selectSelectedDeviceFields } from 'entities/device/lib';
import { useNavigateTo } from 'shared/hooks/router';
const device_selector = selectSelectedDeviceFields([
    'id',
    'name',
    'user_id',
    'gps_state',
    'individual_device_name',
    'capabilities',
]);
function DeviceControlButtonImpl(props) {
    const { closeMenu } = props;
    const [menu_anchor, openSwipableMenu, closeSwipableMenu] = useAnchor();
    const [anchorElPro, onOpenPro, onClosePro] = useAnchor();
    const closeMenus = useCallbacks([closeMenu, closeSwipableMenu]);
    const boilers_loaded = useAppSelector((state) => state.boiler_models.loaded);
    const device = useAppSelector(device_selector);
    const navigate = useNavigateTo(`/new-device`);
    const addDevice = useCallback(() => {
        closeSwipableMenu();
        navigate();
        closeMenu();
        // addStepToWizard(state.keys, state.data, state.device_id);
        // if (!boilers_loaded) {
        //     load_boilers();
        // }
    }, [closeMenu, closeSwipableMenu, boilers_loaded]);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: openSwipableMenu, sx: { borderRadius: 50 }, startIcon: _jsx(BuildRounded, {}), variant: "outlined", color: "info", children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u043C" }), device && (_jsx(DeviceControlMenu, { anchor: menu_anchor, onClose: closeSwipableMenu, addDevice: addDevice, device_name: device.individual_device_name || device.name, gps_state: device?.gps_state, closeMenus: closeMenus, openProPopup: onOpenPro, device_id: device.id, user_id: device.user_id })), _jsx(ProPopup, { anchorEl: anchorElPro, onClose: onClosePro, text: `Создание и редактирование групп доступно в тарифе ${getTariffProName()}!` })] }));
}
export const DeviceControlButton = memo(DeviceControlButtonImpl);
